import styled from "@emotion/styled";
import React from "react";
import Marquee from "../../Marquee";
import RaffleAvatar from "./RaffleAvatar";
import { default as RaffleTicketIcon } from "/public/assets/raffle-ticket.svg?react";

type Props = {
  participants: {
    avatar: string | null;
    tokens: number;
  }[];
};

export default function RaffleParticipantsMarquee(props: Props) {
  return (
    <Root>
      <Marquee
        items={props.participants.map((participant, index) => (
          <MarqueeItem key={index}>
            <RaffleAvatar src={participant.avatar} />
            <RaffleTicketIconSmallWrapper>
              <RaffleTicketIconSmall />
              <span>{participant.tokens}</span>
            </RaffleTicketIconSmallWrapper>
          </MarqueeItem>
        ))}
      />
    </Root>
  );
}

const RaffleTicketIconSmallWrapper = styled.div`
  position: absolute;
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);

  display: flex;
  align-items: center;
  justify-content: center;

  span {
    position: absolute;
    display: block;
    text-align: center;
    width: 100%;
    color: #fff;
    font-size: 14px;
  }
`;

const RaffleTicketIconSmall = styled(RaffleTicketIcon)`
  width: 40px;
`;

const MarqueeItem = styled.div`
  position: relative;
`;

const Root = styled.div`
  background: rgba(255, 255, 255, 0.2);
  padding: 16px 0;
`;
